export default __webpack_public_path__ + "static/media/BCA12.85efcc85.jpg";